import { animate, keyframes, style, transition, trigger } from '@angular/animations';

export const MOBILE_CONTENT_NAVIGATION_ANIMATIONS = [
    trigger('listState', [
        transition(':enter', animate('300ms ease-in-out', keyframes([
            style({
                transform: 'translateY(-100%)'
            }),
            style({
                transform: 'translateY(0)'
            })
        ]))),
        transition(':leave', animate('300ms ease-in-out', keyframes([
            style({
                transform: 'translateY(0)'
            }),
            style({
                transform: 'translateY(-100%)'
            })
        ])))
    ])
];
